import React from "react";
import { css } from "@emotion/react";
import { CometChat } from "@cometchat-pro/chat";
import { MsgPosition } from "components/chat/types";
import Sender from "components/chat/shared/Sender";
import TimeStamp from "components/chat/shared/TimeStamp";
import { bubbleStyle } from "components/chat/shared/BubbleUtil";
import DotMenu from "components/atoms/DotMenu";

// mui
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { grey, blue } from "@mui/material/colors";

const style = {
  msgBox: (position: MsgPosition) => css`
    border-radius: 12px;
    padding: 8px 16px;
    font-size: 0.9rem;
    ${position === "left" &&
    `
      background-color: ${grey[100]};
    `}
    ${position === "right" &&
    `
      background-color: ${blue[500]};
      color: white;
    `}
  `,
  msg: css`
    margin: 0;
    white-space: pre-wrap;
    word-break: break-word;
    text-align: left;
  `,
};

type BubbleTextProps = {
  msg: CometChat.TextMessage;
  position: MsgPosition;
  isMyMsg: boolean;
  handleMsgEdit: (textMsg: CometChat.TextMessage) => void;
  handleMsgDelete: (msg: CometChat.BaseMessage) => void;
};

const BubbleText: React.FC<BubbleTextProps> = (props) => {
  const { msg, position, isMyMsg, handleMsgEdit, handleMsgDelete } = props;

  const handleEdit = () => {
    handleMsgEdit(msg);
  };

  const handleDelete = () => {
    handleMsgDelete(msg);
  };

  return (
    <Box css={bubbleStyle.root(position)}>
      <Box css={bubbleStyle.child}>
        <Box css={bubbleStyle.box(position)}>
          <Sender sender={msg.getSender()} />
        </Box>
        <Box css={style.msgBox(position)}>
          <p css={style.msg}>{msg.getText()}</p>
        </Box>
        <Box css={bubbleStyle.box(position)}>
          <Stack direction="row" alignItems="center">
            {isMyMsg && (
              <DotMenu
                options={[
                  {
                    children: <>edit</>,
                    handleClick: handleEdit,
                  },
                  {
                    children: <>delete</>,
                    handleClick: handleDelete,
                  },
                ]}
              />
            )}
            <TimeStamp msg={msg} />
          </Stack>
        </Box>
      </Box>
    </Box>
  );
};

export default BubbleText;
